import plataformaApi from '@/services/plataforma/academic';

export default {
  async actionGetBatchesProcess(_, { page, perPage, search, statusId, stepId, academicMainId, sortDirection, orderBy }) {
    return plataformaApi.getBatchesProcess({ page, perPage, search, statusId, stepId, academicMainId, sortDirection, orderBy })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  async actionGetBatchesProcessFilters(_, params) {
    return plataformaApi.getBatchesProcessFilters(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  async actionStartBatchProcess(_, params) {
    return plataformaApi.startBatchProcess(params)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  async actionGetBatchEvaluationBlocks(_, params) {
    return plataformaApi.getBatchEvaluationBlocks(params)
      .then((response) => {
        return Promise.resolve(response.data);
      }).catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  }
};
